import emailjs from "@emailjs/browser";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;
const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "Sky High NTB";

const generateCardApplicationHTML = (userData, cardApplication) => {
  const userLink = `${process.env.REACT_APP_BASE_URL || "https://skyhighntb.com"}/userdetail/${userData.uid}`;
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        .header { background: linear-gradient(to right, #8b0000, #dc143c); color: #ffffff; padding: 30px; text-align: center; border-radius: 10px 10px 0 0; }
        .info-box { background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 15px 0; }
        .info-box p { margin: 10px 0; }
        .label { font-weight: bold; color: #2C3D4F; }
        .btn { display: inline-block; padding: 12px 30px; background: #2C3D4F; color: #ffffff; text-decoration: none; border-radius: 5px; margin: 20px 0; }
        .footer { text-align: center; padding: 20px; color: #888; font-size: 12px; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>New Card Application</h1>
        </div>
        <div class="content">
          <p>A new card application has been submitted on ${BRAND_NAME}.</p>
          
          <div class="info-box">
            <p><span class="label">User Name:</span> ${userData.fullName}</p>
            <p><span class="label">Email:</span> ${userData.email}</p>
            <p><span class="label">Account Number:</span> ${userData.accountNumber}</p>
            <p><span class="label">Card Type:</span> ${cardApplication.cardType}</p>
            <p><span class="label">Billing Address:</span> ${cardApplication.address}</p>
            <p><span class="label">Application Number:</span> ${cardApplication.applicationNumber}</p>
            <p><span class="label">Status:</span> ${cardApplication.status}</p>
            <p><span class="label">Report:</span> ${cardApplication.report}</p>
          </div>
          
          <div style="text-align: center;">
            <a href="${userLink}" class="btn">View User</a>
          </div>
        </div>
        <div class="footer">
          <p>${BRAND_NAME} Admin Notification</p>
        </div>
      </div>
    </body>
    </html>
  `;
};

export const sendCardApplicationNotification = async (userData, cardApplication) => {
  console.log("📧 Sending card application notification...", { SUPPORT_EMAIL });
  try {
    const html = generateCardApplicationHTML(userData, cardApplication);
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        user_name: "Admin",
        user_email: SUPPORT_EMAIL,
        html: html,
      },
      PUBLIC_KEY
    );
    console.log("✅ Card application notification sent:", response);
    return true;
  } catch (error) {
    console.error("❌ Error sending card application notification:", error);
    return false;
  }
};